export enum ChargeType {
  Convicted = 'C',
  ActiveDeferral = 'AD',
  CompleteDeferral = 'CD',
  OtherNonConviction = 'N',
  Pending = 'P'
}



// WEBPACK FOOTER //
// ./src/models/chargeType.ts